import { hashKey } from '@tanstack/react-query';

// Inclusive calendar three-month interval anchored to the accepted factor date.
// The shared engine resolves its preceding valuation baseline separately.
export function initialReplayInterval(snapshotDate) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(snapshotDate || '')) return '3M';
    const end = new Date(`${snapshotDate}T00:00:00Z`);
    if (!Number.isFinite(end.getTime())) return '3M';
    const month = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() - 3, 1));
    const last = new Date(Date.UTC(month.getUTCFullYear(), month.getUTCMonth() + 1, 0)).getUTCDate();
    month.setUTCDate(Math.min(end.getUTCDate(), last) + 1);
    return `${month.toISOString().slice(0, 10)}..${snapshotDate}`;
}

export function historicalRequestScope({ userUid, actualPortfolioVersion, watchlistVersion, factorContext }) {
    return hashKey([userUid ?? '', actualPortfolioVersion ?? 0, watchlistVersion ?? 0, factorContext || null]);
}

// The portfolio whose current holdings stay constant. Its stable UI identity is
// separate from the versioned context digest the server issues for it.
export const ACTUAL_HOLDINGS_SOURCE = Object.freeze({ kind: 'actual' });
export const holdingsSourceKey = (source) => (source?.kind === 'optimized' ? `optimized:${source.portfolioId}` : source?.kind || 'actual');

// Request locator; omitted for Actual so existing Actual requests are unchanged.
export function constantSourceRequest(source) {
    if (!source || source.kind === 'actual') return null;
    return source.kind === 'optimized' ? { kind: 'optimized', portfolio_id: source.portfolioId } : { kind: source.kind };
}

export function constantSourceQuery(request) {
    if (!request) return '';
    const params = new URLSearchParams({ constant_source_kind: request.kind });
    if (request.portfolio_id != null) params.set('constant_source_portfolio_id', String(request.portfolio_id));
    return params.toString();
}

// A response describes the requested holdings; Actual responses may omit them.
export function holdingsSourceMatches(holdings, request) {
    const kind = holdings?.kind || 'actual';
    if (kind !== (request?.kind || 'actual')) return false;
    return kind !== 'optimized' || Number(holdings.portfolio_id) === Number(request.portfolio_id);
}
